import { createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() =>
  createStyles({
    root: {
      flexDirection: 'column',
      fontSize: '2em',
      height: '90vh',
      padding: '4vh 2vw',
    },
    subtitle: {
      fontFamily: 'Montserrat',
      fontSize: '1.2em',
      fontWeight: 'bold',
      margin: '0 0 2vh',
      textAlign: 'left',
      textTransform: 'uppercase',
    },
    listStyle: {
      display: 'flex',
      margin: '2vh 0',
      justifyContent: 'center',
      borderColor: 'transparent',
    },
  })
);
